import { render, staticRenderFns } from "./reviewStatusProxy.vue?vue&type=template&id=08ba1860"
import script from "./reviewStatusProxy.vue?vue&type=script&lang=js"
export * from "./reviewStatusProxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ba1860')) {
      api.createRecord('08ba1860', component.options)
    } else {
      api.reload('08ba1860', component.options)
    }
    module.hot.accept("./reviewStatusProxy.vue?vue&type=template&id=08ba1860", function () {
      api.rerender('08ba1860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/review/reviewStatusProxy.vue"
export default component.exports